<form novalidate #currentForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">
        <div class="label"><b>Name</b></div>
      </div>
      <div class="group test-name">
        <input
          matInput
          autocomplete="off"
          type="text"
          class="input-data"
          name="testName"
          #testNameInput="ngModel"
          [(ngModel)]="testName"
          (ngModelChange)="nameUpdated()"
          maxlength="80"
          required
        />
        <div
          class="error"
          *ngIf="testNameInput.invalid && (testNameInput.dirty || testNameInput.touched)"
        >
          <mat-error *ngIf="testNameInput?.errors?.required">Name is required</mat-error>
          <mat-error *ngIf="testNameInput.errors.regex && !testNameInput.errors.required"
            >Name should not contain '?,%,/' special characters</mat-error
          >
        </div>
        <div *ngIf="nameExist">
          <mat-error>Name already exist</mat-error>
        </div>
      </div>
    </div>

    <div class="section-container site-container">
      <div class="label-data label"><b>Endpoints</b></div>
      <div class="site-section">
        <nrwl-endpoint-selection-panel
          [endpointValue]="originatorValue"
          [editMode]="editMode"
          (openEndpoint)="viewOriginator()"
          [endpointConfiguration]="originatorConfiguration"
        >
        </nrwl-endpoint-selection-panel>
        <div class="icon">
          <i class="mdi mdi-ray-start-vertex-end separator-icon"></i>
        </div>
        <nrwl-endpoint-selection-panel
          [endpointValue]="destinationValue"
          [editMode]="editMode"
          (openEndpoint)="viewDestination()"
          [endpointConfiguration]="destinationConfiguration"
        ></nrwl-endpoint-selection-panel>
      </div>
    </div>
    <form novalidate #thresholdForm="ngForm">
      <div class="section-container" *ngIf="hasThresholdData()">
        <div class="label-data label"><b>Thresholds</b></div>
        <div class="threshold-table">
          <div class="header-row row-item">
            <div class="cell-item">KPI</div>
            <div class="cell-item">From Originator</div>
            <div class="cell-item">From Destination</div>
            <div class="cell-item">2-way</div>
          </div>
          <div class="cell-row row-item">
            <div class="cell-item">Delay</div>
            <div class="cell-item">
              <div class="item-content">
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-item"
                  [min]="networkKPIDatasource.originatorDelay.minValue"
                  [max]="networkKPIDatasource.originatorDelay.maxValue"
                  name="originatorDelay"
                  #originatorDelayInput="ngModel"
                  (ngModelChange)="thresholdValueUpdated('originatorDelay')"
                  [(ngModel)]="networkKPIDatasource.originatorDelay.thresholdValue"
                  maxlength="4"
                  required
                />
                <div class="unit">{{ networkKPIDatasource.originatorDelay.unit }}</div>
              </div>
              <div
                class="error"
                *ngIf="
                  originatorDelayInput.invalid &&
                  (originatorDelayInput.dirty || originatorDelayInput.touched)
                "
              >
                <mat-error *ngIf="originatorDelayInput?.errors?.required">required</mat-error>
                <mat-error
                  *ngIf="originatorDelayInput.errors?.min || originatorDelayInput.errors?.max"
                >
                  value should be {{ networkKPIDatasource.originatorDelay.minValue }} to
                  {{ networkKPIDatasource.originatorDelay.maxValue }}</mat-error
                >
              </div>
            </div>

            <div class="cell-item">
              <div class="item-content">
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-item"
                  [min]="networkKPIDatasource.destinationDelay.minValue"
                  [max]="networkKPIDatasource.destinationDelay.maxValue"
                  name="destinationDelay"
                  #destinationDelayInput="ngModel"
                  [(ngModel)]="networkKPIDatasource.destinationDelay.thresholdValue"
                  (ngModelChange)="thresholdValueUpdated('destinationDelay')"
                  maxlength="4"
                  min="0"
                  required
                />
                <div class="unit">{{ networkKPIDatasource.destinationDelay.unit }}</div>
              </div>
              <div
                class="error"
                *ngIf="
                  destinationDelayInput.invalid &&
                  (destinationDelayInput.dirty || destinationDelayInput.touched)
                "
              >
                <mat-error *ngIf="destinationDelayInput?.errors?.required">required</mat-error>
                <mat-error
                  *ngIf="destinationDelayInput.errors?.min || destinationDelayInput.errors?.max"
                >
                  value should be {{ networkKPIDatasource.destinationDelay.minValue }} to
                  {{ networkKPIDatasource.destinationDelay.maxValue }}</mat-error
                >
              </div>
            </div>
            <div class="cell-item">{{ getTwoWayValue('originatorDelay', 'destinationDelay') }}</div>
          </div>
          <div class="cell-row row-item">
            <div class="cell-item">Jitter</div>
            <div class="cell-item">
              <div class="item-content">
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-item"
                  name="originatorJitter"
                  #originatorJitterInput="ngModel"
                  [min]="networkKPIDatasource.originatorJitter.minValue"
                  [max]="networkKPIDatasource.originatorJitter.maxValue"
                  [(ngModel)]="networkKPIDatasource.originatorJitter.thresholdValue"
                  (ngModelChange)="thresholdValueUpdated('originatorJitter')"
                  maxlength="4"
                  required
                />
                <div class="unit">{{ networkKPIDatasource.originatorJitter.unit }}</div>
              </div>
              <div
                class="error"
                *ngIf="
                  originatorJitterInput.invalid &&
                  (originatorJitterInput.dirty || originatorJitterInput.touched)
                "
              >
                <mat-error *ngIf="originatorJitterInput?.errors?.required">required</mat-error>
                <mat-error
                  *ngIf="originatorJitterInput.errors?.min || originatorJitterInput.errors?.max"
                >
                  value should be {{ networkKPIDatasource.originatorJitter.minValue }} to
                  {{ networkKPIDatasource.originatorJitter.maxValue }}</mat-error
                >
              </div>
            </div>
            <div class="cell-item">
              <div class="item-content">
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-item"
                  [min]="networkKPIDatasource.destinationJitter.minValue"
                  [max]="networkKPIDatasource.destinationJitter.maxValue"
                  name="destinationJitter"
                  #destinationJitterInput="ngModel"
                  [(ngModel)]="networkKPIDatasource.destinationJitter.thresholdValue"
                  (ngModelChange)="thresholdValueUpdated('destinationJitter')"
                  maxlength="4"
                  required
                />
                <div class="unit">{{ networkKPIDatasource.destinationJitter.unit }}</div>
              </div>
              <div
                class="error"
                *ngIf="
                  destinationJitterInput.invalid &&
                  (destinationJitterInput.dirty || destinationJitterInput.touched)
                "
              >
                <mat-error *ngIf="destinationJitterInput?.errors?.required">required</mat-error>
                <mat-error
                  *ngIf="destinationJitterInput.errors?.min || destinationJitterInput.errors?.max"
                >
                  value should be {{ networkKPIDatasource.destinationJitter.minValue }} to
                  {{ networkKPIDatasource.destinationJitter.maxValue }}</mat-error
                >
              </div>
            </div>
            <div class="cell-item">
              {{ getTwoWayValue('originatorJitter', 'destinationJitter') }}
            </div>
          </div>
          <div class="cell-row row-item">
            <div class="cell-item">Packet Loss</div>
            <div class="cell-item">
              <div class="item-content">
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-item"
                  [min]="networkKPIDatasource.originatorPacketLoss.minValue"
                  [max]="networkKPIDatasource.originatorPacketLoss.maxValue"
                  name="originatorPacketLoss"
                  #originatorPacketLossInput="ngModel"
                  [(ngModel)]="networkKPIDatasource.originatorPacketLoss.thresholdValue"
                  (ngModelChange)="thresholdValueUpdated('originatorPacketLoss')"
                  maxlength="4"
                  required
                />
                <div class="unit">{{ networkKPIDatasource.originatorPacketLoss.unit }}</div>
              </div>
              <div
                class="error"
                *ngIf="
                  originatorPacketLossInput.invalid &&
                  (originatorPacketLossInput.dirty || originatorPacketLossInput.touched)
                "
              >
                <mat-error *ngIf="originatorPacketLossInput?.errors?.required">required</mat-error>
                <mat-error
                  *ngIf="
                    originatorPacketLossInput.errors?.min || originatorPacketLossInput.errors?.max
                  "
                >
                  value should be {{ networkKPIDatasource.originatorPacketLoss.minValue }} to
                  {{ networkKPIDatasource.originatorPacketLoss.maxValue }}</mat-error
                >
              </div>
            </div>
            <div class="cell-item">
              <div class="item-content">
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-item"
                  [min]="networkKPIDatasource.destinationPacketLoss.minValue"
                  [max]="networkKPIDatasource.destinationPacketLoss.maxValue"
                  name="destinationPacketLoss"
                  #destinationPacketLossInput="ngModel"
                  [(ngModel)]="networkKPIDatasource.destinationPacketLoss.thresholdValue"
                  (ngModelChange)="thresholdValueUpdated('destinationPacketLoss')"
                  maxlength="4"
                  required
                />
                <div class="unit">{{ networkKPIDatasource.destinationPacketLoss.unit }}</div>
              </div>
              <div
                class="error"
                *ngIf="
                  destinationPacketLossInput.invalid &&
                  (destinationPacketLossInput.dirty || destinationPacketLossInput.touched)
                "
              >
                <mat-error *ngIf="destinationPacketLossInput?.errors?.required">required</mat-error>
                <mat-error
                  *ngIf="
                    destinationPacketLossInput.errors?.min || destinationPacketLossInput.errors?.max
                  "
                >
                  value should be {{ networkKPIDatasource.destinationPacketLoss.minValue }} to
                  {{ networkKPIDatasource.destinationPacketLoss.maxValue }}</mat-error
                >
              </div>
            </div>
            <div class="cell-item">
              {{ getTwoWayValue('originatorPacketLoss', 'destinationPacketLoss') }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</form>
